import { StyleDeclarationValue, css } from 'aphrodite';
import { RatingGraphic } from '../../../web/components/svgs/graphics/RatingGraphic';
import { Survey } from '../SurveyResponses/shared/Survey';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

export function SurveyUnavailable({ className = '', styles = [] }: IProps) {
	return (
		<Survey className={`survey-unavailable-container ${className || ''}`} styles={styles}>
			<div className={css(styleSheet.unavailable)}>
				<RatingGraphic />
				<div>This survey is not available at this time.</div>
			</div>
		</Survey>
	);
}
